__turbopack_context__.v({
  "className": "caveat_1841fa23-module__9B--fW__className",
  "variable": "caveat_1841fa23-module__9B--fW__variable",
});
